module.exports = __webpack_public_path__ + "01ea978f/img/ion_calendar-number.3ac5bd07.svg";